import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
	DatePicker, message,
	Button, Row, Col, Input,
	Icon, Modal, Form, Spin, Divider
} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeInterviewManagement,
	selectInterviewManagement,
} from "../../actions/recruitment-actions";
import interviewManagementService from "../../services/Recruitment/interview-management-service";
const webConfig = require ('../../config.json');
const numberMap = ["初面", "一面", "二面", "三面", "四面", "五面", "多面"];


class InterviewManagement extends ReduxComponent {

	initReload = true;
	deleteRowSelection = true;
	moduleName = "recruitment";
	childModuleName = "interviewManagement";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
		currentDataStatus: "unload"
	}

	actions = {
		changeAction: this.props.changeInterviewManagement,
		selectAction: this.props.selectInterviewManagement,
		exportAction: interviewManagementService.exportInterviewManagement
	}

	setStartDateFilter = (moment, date)=> this.actions.changeAction({search_start_time: date}, "reload")

	setEndDateFilter = (moment, date)=> this.actions.changeAction({search_end_time: date}, "reload")

	selectInterviewDetail = id => this.setState({
		currentModalStatus: true,
		currentDataStatus: "loaded"
	}, () => interviewManagementService.selectInterviewManagementDetail({modelId: id}, res => {
		console.log(res)
		if (200 === res.status) {
			this.setState({
				currentData: {
					id: id,
					...res.data
				}
			}, () => console.log(this.state))
		}else{
			this.setState({currentDataStatus: "error"})
		}
	}, err => this.setState({currentDataStatus: "error"})))

	submitInterviewReply = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			let postReplyData = {
				id: this.state.currentData.id,
				...values
			}
			interviewManagementService.replyInterviewManagementDetail(postReplyData, res => {
				if (res.data.Success) {
					message.success("回复面试成功", 4);
					this.setState({currentModalStatus: false})
				}else{
					message.error("回复面试失败", 4);
				}
			})
		}
	})

	column = [
        {
            title: '面试日期',
            dataIndex: 'arrange_inte_time_str',
            key: 'arrange_inte_time_str',
            className: 'table-global-head-large'
        }, {
            title: '面试时间',
            dataIndex: 'actual_inte_time',
            key: 'actual_inte_time',
            className: 'table-global-head-large'
        },{
            title: '面试职位',
            dataIndex: 'interview_jobs',
            key: 'interview_jobs',
            className: 'table-global-head-small'
        }, {
			title: '姓名',
			dataIndex: 'username',
			key: 'username',
			className: 'table-global-head-small'
		}, {
			title: '联系电话',
			dataIndex: 'mobile',
			key: 'mobile',
			className: 'table-global-head-short'
		}, {
			title: '邮箱',
			dataIndex: 'email',
			key: 'email',
			className: 'table-global-head-large'
		},  {
			title: '面试轮次',
			dataIndex: 'interview_times',
			key: 'interview_times',
			className: 'table-global-head-small'
		}, {
			title: '面试官',
			dataIndex: 'interviewer_name',
			key: 'interviewer_name',
			className: 'table-global-head'
		}, {
			title: '状态',
			dataIndex: 'interview_status_str',
			key: 'interview_status_str',
			className: 'table-global-head-small'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-short',
			render: (text, record, index) => {
				return this.props.access.interviewManagement.reply_value &&
					<span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.selectInterviewDetail.bind(this, record.id)}>面试回复</Button>
					</span>

			} 
		}
	];

	render() {
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="简历库"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					onOk={this.submitInterviewReply} >
					<div className="app-modal-item">
					{(() => {
						switch (this.state.currentDataStatus) {
							case "reload":
							case "loaded":
								return (
									<div>
										<Row>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													姓名:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.username}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													年龄:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.age}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													联系电话:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.mobile}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													邮箱:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.email}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													期望职位:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.dream_position}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													期望年薪:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.expected_salary}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													面试职位:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.interview_jobs}
												</span>
											</Col>
											<Col span={12} style={{marginBottom: "15px"}}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>
													面试轮次:
												</span>
												<span style={{width: "240px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.interview_times}
												</span>
											</Col>
										</Row>
										<Form onSubmit={this.submitInterviewReply} className="login-form" layout="inline">
												<Col span={24}>
													<div style={{marginBottom:"15px"}}>
														<Form.Item label={numberMap[this.state.currentData.interview_times] + "结论"}>
															{this.props.form.getFieldDecorator('suggestion', {
																initialValue: this.state.currentData.suggestion
															})(<Input.TextArea rows={5} style={{width: "716px"}}>
															</Input.TextArea>)}
														</Form.Item>
													</div>
												</Col>
										</Form>
											<Divider type="horizontal">其他反馈信息</Divider>
											<div>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>简历分析建议:</span>
												<span style={{width: "716px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{this.state.currentData.suggestion}
												</span>
											</div>
											{false && this.state.currentData.suggestions && this.state.currentData.suggestions.map((suggestion, index) => (
											<div key={index}>
												<span style={{width: "120px", display: "inline-block",textAlign: "right"}}>{suggestion.id}: </span>
												<span style={{width: "716px", display: "inline-block",textAlign: "left",paddingLeft: "10px"}}>
													{suggestion.suggestion}
												</span>
											</div>
											))}
									</div>)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{this.props.access.interviewManagement.export_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicExport}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>结束时间 : </span>
						<DatePicker onChange={this.setEndDateFilter} 
							value={this.props[this.moduleName][this.childModuleName].filters.search_end_time ?
								moment(this.props[this.moduleName][this.childModuleName].filters.search_end_time) : null}/>
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>开始时间 : </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props[this.moduleName][this.childModuleName].filters.search_start_time ?
								moment(this.props[this.moduleName][this.childModuleName].filters.search_start_time) : null} />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment
	}
}

const mapDispatchToProps = {
	changeInterviewManagement,
	selectInterviewManagement,
}

InterviewManagement = Form.create()(InterviewManagement);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(InterviewManagement));









// WEBPACK FOOTER //
// ./src/routes/Recruitment/InterviewManagement.js